import { cva } from 'class-variance-authority';

/**
 * Shared tag variants for consistent styling across different tag components
 */
export const tagVariants = cva(
  // Base styles that apply to all tags
  'flex h-[32px] min-h-[30px] items-center justify-center truncate whitespace-nowrap rounded border border-transparent px-4 py-1 font-semibold transition-all hover:cursor-pointer',
  {
    variants: {
      status: {
        pending: 'bg-skyBlue text-[#425FA9] hover:border-[#425FA9]',
        purchased: 'bg-[#7CFDD7] text-[#207259] hover:border-[#207259]',
        received: 'bg-[#9cf2fc] text-[#046f7b] hover:border-[#046f7b]',
        completed: 'bg-[#78edb7] text-[#0f7044] hover:border-[#0f7044]',
        notSent: 'bg-accentDuskyPink text-[#7D5D57] hover:border-[#7D5D57]',
        canceled: 'bg-[#fd9ba7] text-[#7d0212] hover:border-[#7d0212]',
        placed: 'bg-[#FFE9AF] text-[#78683D] hover:border-[#78683D]',
        ordered: 'bg-[#9baefd] text-[#021b7d] hover:border-[#021b7d]',
        shipped:
          'bg-[#f4cdfe] fill-[#65037d] text-[#65037d] hover:border-[#65037d]',
        default: '',
      },
      size: {
        default: 'max-w-[160px] xs:max-w-[240px]',
        small: 'max-w-[120px] xs:max-w-[180px]',
        large: 'max-w-[200px] xs:max-w-[280px]',
      },
      variant: {
        standard: '',
        removable: 'py-2 pl-4 pr-3 gap-3 font-secondary text-sm',
      },
    },
    defaultVariants: {
      status: 'default',
      size: 'default',
      variant: 'standard',
    },
  },
);

/**
 * Close icon variants for removable tags
 */
export const closeIconVariants = cva(
  'flex items-center justify-center transition',
  {
    variants: {
      status: {
        pending: 'fill-[#425FA9] hover:fill-[#6882c3]',
        purchased: 'fill-[#207259] hover:fill-[#3b9b7e]',
        received: 'fill-[#046f7b] hover:opacity-50',
        completed: 'fill-[#0f7044] hover:opacity-50',
        notSent: 'fill-[#7D5D57] hover:fill-[#ad867f]',
        canceled: 'fill-[#7d0212] hover:opacity-50',
        placed: 'fill-[#78683D] hover:fill-[#a08e5f]',
        ordered: 'fill-[#021b7d] hover:opacity-50',
        shipped: 'fill-[#65037d] hover:opacity-50',
        default: 'hover:opacity-50',
      },
    },
    defaultVariants: {
      status: 'default',
    },
  },
);

/**
 * Helper function to determine tag status from tag text
 */
export const getTagStyle = (tag: string) => {
  const lowercaseTag = tag.toLowerCase();

  if (lowercaseTag.includes('pending')) return 'pending';
  if (lowercaseTag.includes('purchased')) return 'purchased';
  if (lowercaseTag.includes('received')) return 'received';
  if (lowercaseTag.includes('completed')) return 'completed';
  if (lowercaseTag.includes('not sent')) return 'notSent';
  if (lowercaseTag.includes('canceled')) return 'canceled';
  if (lowercaseTag.includes('placed')) return 'placed';
  if (lowercaseTag.includes('ordered')) return 'ordered';
  if (lowercaseTag.includes('shipped')) return 'shipped';
  return 'default';
};
